import {messages} from './messages'

export const messagesFr: typeof messages = {
  all: 'Tout',
  account: 'Compte',
  accounts: 'Comptes',
  accept: 'Accepter',
  contact: 'Contact',
  name: 'Nom',
  firstName: 'Prénom',
  lastName: 'Nom',
  description: 'Description',
  address: 'Adresse',
  search: 'Rechercher',
  edit: 'Modifier',
  next: 'Suivant',
  nextStep: 'Étape suivante',
  close: 'Fermer',
  end: 'Fin',
  see: 'Voir',
  test: 'Simuler',
  date: 'Date',
  client: 'Client',
  amount: 'Montant',
  amount_engaged: 'Montant engagé',
  amount_target: 'Montant ciblé',
  fees: 'Frais',
  add: 'Ajouter',
  previous: 'Précédent',
  signatures: 'Signature',
  signatures_documents: 'Doc&Sign',
  chooseFile: 'Choisissez un fichier',
  invalidFileSize: 'Limite de taille de fichier dépassée',
  invalidDate: 'Format de date invalide',
  invalidText: 'Réponse invalide',
  noFile: 'Aucun fichier disponible',
  back: 'Retour',
  delete: 'Supprimer',
  deleted: 'Supprimé',
  try: 'Essayer',
  user: 'Utilisateur',
  users: 'Utilisateurs',
  enterprise: 'Client',
  enterprises: 'Clients',
  fundraise: 'Projet',
  fundraises: 'Projets',
  settings: 'Paramètres',
  status: 'Statut',
  document: 'Document',
  documents: 'Documents',
  download: 'Télécharger',
  downloading: 'Téléchargement',
  form: 'Formulaire client',
  forms: 'Formulaires clients',
  metric: 'Tarificateur',
  metrics: 'Tarificateurs',
  fileInvalidSize: 'La taille du fichier ne doit pas dépasser 10 Mo',
  selectAForm: 'Choisissez un formulaire',
  selectAMetric: 'Choisissez une offre',
  codeChecksum: 'Code',
  script: 'Script',
  home: 'Accueil',
  save: 'Enregistrer',
  saved: 'Enregistré',
  duplicate: 'Dupliquer',
  minimize: 'Diminuer',
  required: 'Requis',
  logout: 'Déconnexion',
  newForm: 'Nouveau form',
  phone: 'Téléphone mobile',
  email: 'Email',
  subscription: 'Souscription',
  personalize: 'Personnaliser',
  cancel: 'Annuler',
  created_at: 'Crée le',
  percent: 'Pourcent',
  validated: 'Validé',
  dashboard: 'Accueil',
  configuration: 'Configuration',
  general: 'General',
  main_phone: 'Téléphone principal',
  topaze_id: 'ID Topaze',
  efs_code: 'Code EFS',
  efs_name: 'Nom EFS',
  customer_sdm: 'Clients',
  job: 'Fonction',
  birthday: 'Date de naissance',
  birthplace: 'Lieu de naissance',
  terminate: 'Terminer',
  manager_title: 'Espace client',
  not_available: 'Non disponible',
  year_amount: 'an',
  years_amount: 'ans',
  months_amount: 'mois',
  confirm: 'Confirmer',
  arkea: 'ARKEA',
  news: 'Actualités',
  eco_watch: 'Etudes économiques',
  categories: 'Catégories',
  load_more: 'Voir plus',
  market_hall_portal: 'Portail Salle des Marchés',
  tag: 'Tag',
  tags: 'Tags',
  sign: 'Signer',
  actions: 'Actions',
  document_to_sign: 'Documents à signer',
  document_signed: 'Documents signés',
  document_other: 'Documents à consulter',
  document_and_signature: 'Documents et signatures',
  rcs_city: 'Ville RCS du représentant légal',
  siren: 'Numéro SIREN du représentant légal',
  products: 'Produits',
  product: 'Produit',
  cotation: 'Cotation',
  cotations: 'Cotations',
  ask_cotation: 'Demande de cotation',
  send: 'Envoyer',
  none: 'Aucune',
  search_placeholder: 'Recherche...',
  other: 'Autre',
  type_your_answer: 'Tapez votre réponse...',
  detail: 'Détails',
  action_success: 'Action terminée avec succès',
  transactions: 'Transactions',
  yes: 'Oui',
  no: 'Non',
  operations: 'Opérations',
  no_data: 'Aucune donnée disponible',
  last_oprations: 'Dernières opérations',
  last_documents: 'Derniers documents',
  last_cotations: 'Dernières cotations',
  my_clearances: 'Vos habilitations',
  on_the_front_page: 'A la une',
  notification: 'Notifications',
  cloud_tags: 'Nuage de tags',
  export: 'Exporter',
  market_indicators: "Indicateurs de marchés",
  email_subscription: 'Abonnez-vous',
  consult: 'Consulter',
  requester: 'Demandeur',
  send_document: 'Envoi de documents',
  random_error: 'Il y a eu un problème, veuillez réessayer',

  fundraiseType_FUNDRAISE_LOAN: 'Prêt',
  fundraiseType_FUNDRAISE_EQUITY: 'Actions',
  fundraiseType_undefined: 'Autres',

  fundraiseStatus_INIT: 'Création',
  fundraiseStatus_RUNNING: 'En cours',
  fundraiseStatus_DELETED: 'Supprimé',
  fundraiseStatus_UNDER_REVIEW: 'Analyse',
  fundraiseStatus_REFUND_ONGOING: 'Remboursement en cours',
  fundraiseStatus_REFUNDED: 'Remboursé',
  fundraiseStatus_SUCCEEDED: 'Financé avec succès',

  Template_REWARD: 'Plateforme de don',
  Template_LOAN_EQUITY: 'Plateforme de prêt/actions',
  Template_AAP: 'Plateforme d\'appels à projets',
  Template_undefined: 'API Sandbox',

  Users_title: 'Gestion des utilisateurs',
  Users_created_at: 'Inscription',

  Fundraises_title: 'Projets',
  Fundraises_amount_percent: 'Objectif',
  Fundraises_fundraise_type: 'Type',

  Consumers_title: 'Bienvenue dans votre espace privé Salle des Marchés',
  Consumers_content: 'Gérez vos applications et créez-en de nouvelles sur cette page.',
  Consumers_list_title: 'Vos applications',
  Consumers_doc: 'Documentation',
  Consumers_welcome_without_enterprise: 'Désolé, il semble que votre compte ne soit relié à aucune entité juridique. Veuillez contacter la Salle des Marchés du Groupe ARKEA pour accéder à la plateforme.',
  Consumers_welcome_with_enterprise_first: 'Nous vous invitons à choisir votre compte de connexion',

  ContextLoanEquity_title_allow_indexing: 'Indexing',
  ContextLoanEquity_desc_allow_indexing: 'Allow search engines to index this website',
  ContextLoanEquity_title_privacy: 'Application privée',
  ContextLoanEquity_desc_privacy: 'Empêcher l\'utilisateur non validé de voir le détails des projets',
  ContextLoanEquity_title_offline_payment: 'Paiement hors ligne',
  ContextLoanEquity_desc_offline_payment: 'Rend la validation des transactions manuelle',
  ContextLoanEquity_warning_offline_payment: 'Aucun prestataire de paiement n\'est défini sur votre plateforme, contactez-nous pour en définir un au 01 79 75 66 63 ou par mail à support@particeep.com',
  ContextLoanEquity_header_partner: 'CGP',
  ContextLoanEquity_header_investor: 'Investisseur',
  ContextLoanEquity_header_entrepreneur: 'Entrepreneur',
  ContextLoanEquity_title_partner_enabled: 'Activer les CGP',
  ContextLoanEquity_desc_partner_enabled: 'Permettre aux investisseurs de selectionner un CGP',
  ContextLoanEquity_title_must_fill_form: 'Activer le formulaire',
  ContextLoanEquity_desc_must_fill_form: 'A remplir lors de l\'inscription',
  ContextLoanEquity_title_must_sign_form: 'Activer la signature',
  ContextLoanEquity_desc_must_sign_form: 'A signier lors de l\'inscription',
  ContextLoanEquity_title_investor_auto_validation: 'Auto-validation',
  ContextLoanEquity_desc_investor_auto_validation: 'Investors are automatically validated at the end of their registration\n',
  ContextLoanEquity_title_has_fundraise_equity: 'Investissement en capital',
  ContextLoanEquity_desc_has_fundraise_equity: 'Autoriser les porteurs de projet à créer des opérations en actions',
  ContextLoanEquity_title_has_fundraise_loan: 'Investissement en prêt',
  ContextLoanEquity_desc_has_fundraise_loan: 'Autoriser les porteurs de produit à créer des opérations en prêt',
  ContextLoanEquity_title_pending_transactions_enabled: 'Activer les transactions en attente',
  ContextLoanEquity_desc_pending_transactions_enabled: 'les investisseurs pourront créer une souscription et la payer plus tard',

  DarkTheme_title: 'Thème sombre',
  DarkTheme_desc: 'Le thème sombre assombrit les surfaces claires de la page, créant une expérience idéale pour la nuit. Essaye le!',

  Menu_label: 'Menu',
  Menu_logout: 'Déconnexion',
  Menu_login: 'Connexion',
  Menu_profile: 'Paramètres personnels',
  Menu_changeEnterprise: 'Changer de compte',
  Menu_newsletter: 'Abonnements',
  Menu_password: 'Mot de passe',

  Profile_pageHead: 'Informations personnelles',
  Profile_edit_alert: 'Une fois validées, les informations ci-dessous ne seront plus accessibles (vous devrez contacter la Salle des Marchés du Groupe ARKEA pour les modifier). Veuillez vous assurer que les informations renseignées sont correctes avant de les enregistrer.',
  Profile_cannot_edit_message: 'L\'édition de vos informations est protégée. Si vous souhaitez apporter des modifications, contactez l\'équipe de la Salle des Marchés du Groupe ARKEA',
  Profile_edit_success_message: 'Merci vos informations ont bien été renseignées. L\'édition de vos informations est à nouveau protégée. Si vous souhaitez apporter des modifications, contactez l\'équipe de la Salle des Marchés du Groupe ARKEA',

  Page_Reset_password_title: 'Réinitialisation du mot de passe',
  Page_Reset_password_label: 'Mot de passe',
  Page_Reset_password_confirm_label: 'Confirmation du mot de passe',
  Page_Reset_password_old_label: 'Ancien mot de passe',
  Page_Reset_password_conditions_help: 'Le mot de passe doit respecter les conditions suivantes :',
  Page_Reset_password_conditions_help_first: 'Entre 10 et 16 caractères',
  Page_Reset_password_conditions_help_second: 'Pas plus de deux caractères identiques de suite',
  Page_Reset_password_conditions_help_third: 'Pas de répétition de plus de 3 caractères.',
  Page_Reset_password_conditions_help_fourth: 'Au moins un chiffre',

  Tunnel_Reset_password_first_login_message_1: 'Nous vous invitons à réinitialiser votre mot de passe.',
  Tunnel_Reset_password_first_login_message_2: 'Sa réinitialisation est nécessaire s’il s’agit de votre première connexion ou si votre mot de passe date de plus d’un an.',
  Tunnel_Reset_password_too_old_1: 'Nous vous invitons à réinitialiser votre mot de passe.',
  Tunnel_Reset_password_too_old_2: 'Sa réinitialisation est nécessaire si votre mot de passe date de plus d’un an.',
  Tunnel_Profile_check_title: 'Vérification de votre profil',
  Tunnel_end_toast: 'Informations sauvegardées avec succès',
  Tunnel_end_page_title: 'Merci d\'avoir finalisé la configuration de votre compte',
  Tunnel_end_page_content: 'Vous pouvez désormais accéder à la totalité du site, cliquez sur le bouton ci-dessous pour commencer',
  Tunnel_end_page_link: 'Accéder au tableau de bord',
  Tunnel_Profile_alert_1: 'Rappel de vos informations personnelles.',
  Tunnel_Profile_alert_2: 'Pour toute demande de modification, merci de bien vouloir prendre contact avec la Salle des Marchés du Groupe ARKEA.',

  Edit_profile_first_name: "Prénom",
  Edit_profile_last_name: "Nom de famille",
  Edit_profile_email: "Email",
  Edit_profile_birthday: "Date de naissance",
  Edit_profile_birthplace: "Ville de naissance",
  Edit_profile_birthCodePostal: "Code postal de naissance",
  Edit_profile_pro_phone: "Téléphone principal",
  Edit_profile_mobile_phone: "Téléphone mobile",
  Edit_profile_function: "Fonction",
  Edit_profile_address_number: "Numéro",
  Edit_profile_address_street: "Rue",
  Edit_profile_address_zip: "Code postal de naissance",
  Edit_profile_address_city: "Ville",
  Edit_profile_address_country: "Pays",
  Edit_profile_phone_description: 'Ce numéro est essentiel, Il nous permettra de vous transmettre vos codes de signature électronique.',

  EnterpriseDetail_tab_information: "Informations générales",
  EnterpriseDetail_tab_contractual: "Informations contractuelles",
  EnterpriseDetail_tab_question: "Questionnaire personne",
  EnterpriseDetail_tab_document: "Documents",
  EnterpriseDetail_tab_signature: "Signatures",
  EnterpriseDetail_tab_user: "Utilisateurs",
  EnterpriseDetail_tab_limit: "Limites",
  EnterpriseDetail_tab_physical_person: "Personnes physiques habilitées",

  EnterpriseDetail_info_general_title_first: "Infomations générales",
  EnterpriseDetail_info_general_habilitations_title: "Vos habilitations avec ce compte",
  EnterpriseDetail_info_general_habilitations_caption: "Habilitations sur les produits",
  EnterpriseDetail_info_general_mandataire: "Mandataire",
  EnterpriseDetail_info_general_title_second: "Informations générales du compte",
  EnterpriseDetail_info_general_denomination :"Dénomination",
  EnterpriseDetail_info_general_delegation_emir: "Délégation de déclaration EMIR",
  EnterpriseDetail_info_general_lei: "Legal Entity Identifier (LEI)",
  EnterpriseDetail_info_general_max_operation: "Durée maximum des opérations de change",
  EnterpriseDetail_info_general_rcs_city: "Ville RCS",
  EnterpriseDetail_info_general_siren: "Numéro SIREN",
  EnterpriseDetail_info_web_conf: "Confirmation en ligne",


  EnterpriseInfo_members_col_fullname: 'Nom Prénom',
  EnterpriseInfo_members_col_representative: 'Mandataire',
  EnterpriseInfo_members_col_change: 'Change',
  EnterpriseInfo_members_col_dette: 'Taux',
  EnterpriseInfo_members_col_placement: 'Placement',
  EnterpriseInfo_members_col_notified: 'Accès envoyés',

  EnterpriseDetail_info_contractual_title_first: "Informations contractuelles ",
  EnterpriseDetail_info_contractual_title_edit: "Edition des informations contractuelles",
  EnterpriseDetail_info_contractual_edit_sucess: "Edition a été sauvegardée",
  EnterpriseDetail_info_contractual_editable_description: 'Après avoir vérifié ou modifié vos informations contractuelles, celles-ci seront bloquées jusqu\'à qu\'elles vous soient à nouveau demandées par la Salle des Marchés du Groupe ARKEA.',
  EnterpriseDetail_info_contractual_uneditable_description: 'L\'édition de ces informations est protégée. Si vous souhaitez apporter des modifications, contactez la Salle des Marchés du Groupe ARKEA.',
  EnterpriseDetail_info_contractual_person_to_notify: 'Personne à notifier par la banque',
  EnterpriseDetail_info_contractual_email_person_to_notify: 'Email de la personne à notifier',
  EnterpriseDetail_info_contractual_address_person_to_notify: 'Adresse postale de la personne à notifier',
  EnterpriseDetail_info_contractual_status_emir: 'Statut de compensation EMIR',
  EnterpriseDetail_info_contractual_rcs_city: 'Ville RCS du représentant légal',
  EnterpriseDetail_info_contractual_siren: 'Numéro SIREN du représentant légal',
  EnterpriseDetail_info_contractual_lei: 'Numéro LEI',
  EnterpriseDetail_info_contractual_modal_confirm: 'La récupération de ces données est nécessaire car elles apparaissent dans les documents cadre variabilisés. Assurez-vous que les informations renseignées sont correctes, vous ne pourrez plus les éditer immédiatement après votre confirmation.',
  EnterpriseDetail_info_contractual_status_emir_first_option: 'Contrepartie financière au sens de l\'article 2 du Règlement EMIR',
  EnterpriseDetail_info_contractual_status_emir_second_option: 'Contrepartie financière au sens de l\'article 2(8) du Règlement EMIR, mais ne remplissant pas les conditions de l\'article 10, paragraphe 1, point (b) du Règlement EMIR ("Petite Contrepartie Financière")',
  EnterpriseDetail_info_contractual_status_emir_third_option: 'Contrepartie non financière au sens de l\'article 2 et ne remplissant pas les conditions visées à l\'article 10, paragraphe 1, point (b) du Règlement EMIR',
  EnterpriseDetail_info_contractual_status_emir_fourth_option: 'Contrepartie non financière au sens de l\'article 2 et remplissant les conditions visées à l\'article 10, paragraphe 1, point (b) du Règlement EMIR',
  EnterpriseDetail_info_contractual_status_emir_fifth_option: 'Entité établie dans un ou plusieurs pays tiers à l\'Union européenne qui serait soumise à l\'obligation de compensation si elle était établie dans l\'Union européenne au sens du Règlement EMIR',
  EnterpriseDetail_info_contractual_status_emir_sixth_option: 'Entité établie dans un ou plusieurs pays tiers à l\'Union européenne qui ne serait pas soumise à l\'obligation de compensation si elle était établie dans l\'Union européenne au sens du Règlement EMIR',
  EnterpriseDetail_info_contractual_status_emir_seventh_option: 'Entité exemptée de l\'application de l\'obligation de compensation par une contrepartie centrale au titre du Règlement EMIR',
  EnterpriseDetail_info_contractual_notifications: 'Sauf accord différent des Parties, toute notification effectuée en vertu de la Convention devra être faite par lettre, courrier électronique ou toute transmission électronique ou numérisée présentant un degré suffisant de sécurité et de fiabilité pour les Parties et prendra effet à la date de sa réception si elle est reçue avant dix-sept (17) heures un Jour Ouvré et le Jour Ouvré suivant si elle est reçue après dix-sept (17) heures ou un jour qui n’est pas un Jour Ouvré.',

  EnterpriseDetail_statut_form_skill_experience_lbl: "Expérience seulement",
  EnterpriseDetail_statut_form_skill_connaissance_lbl : "Connaissance seulement",
  EnterpriseDetail_statut_form_skill_non_approprie_lbl : "Non approprié",
  EnterpriseDetail_statut_form_skill_non_repondu_lbl: "Non répondu",
  EnterpriseDetail_statut_form_skill_approprie_lbl: "Approprié",
  EnterpriseDetail_statut_form_skill_approprie_lbl_plus: "Approprié (5+)",
  EnterpriseDetail_statut_form_skill_approprie_lbl_minus: "Approprié (5-)",
  EnterpriseDetail_statut_form_skill_advanced_lbl: "ADVANCED",
  EnterpriseDetail_statut_form_skill_informed_lbl: "INFORMED",
  EnterpriseDetail_statut_form_skill_basic_lbl: "BASIC",
  EnterpriseDetail_statut_form_skill_non_disponible_lbl: "",
  EnterpriseDetail_statut_form_skill_experience_caption: "Attention, vous disposez uniquement de l'expérience pour ce produit par rapport au questionnaire personne.",
  EnterpriseDetail_statut_form_skill_connaissance_caption : "Attention, vous disposez uniquement de la connaissance pour ce produit par rapport au questionnaire personne.",
  EnterpriseDetail_statut_form_skill_non_approprie_caption : "Attention, ce produit n'est pas approprié par rapport aux réponses du questionnaire personne.",
  EnterpriseDetail_statut_form_skill_non_repondu_caption: "Attention, vous n'avez pas répondu aux questions du questionnaire personne relatives à ce produit.",
  EnterpriseDetail_statut_form_skill_approprie_caption: "",

  EnterpriseDetail_form_download_document_signed: "Télécharger le document signé",
  EnterpriseDetail_form_status_pending: "Vérification en cours",
  EnterpriseDetail_form_status_valid: "Validé",
  EnterpriseDetail_form_status_daily_limit_exceeded: "Limite quotidienne dépassée",
  EnterpriseDetail_form_answer_saved: "Réponses enregistrées",
  EnterpriseDetail_form_see_answer: "Voir les réponses",
  EnterpriseDetail_form_pdf_signed: "Document signé",
  EnterpriseDetail_form_alert_form_update: "Attention votre questionnaire personne doit être mis à jour !",
  EnterpriseDetail_form_questionnaire: 'Questionnaire personne',
  EnterpriseDetail_form_next_update: 'Date de prochaine mise à jour:',
  EnterpriseDetail_form_edit_by: 'Edité en ligne par',
  EnterpriseDetail_form_last_response_saved: 'Dernières réponses enregistrées',
  EnterpriseDetail_form_analyse_questionnaire: 'Analyse du questionnaire personne',
  EnterpriseDetail_form_last_updated: 'Dernière mise à jour: ',
  EnterpriseDetail_signed_by: "Signé par",
  EnterpriseDetail_doc_name: "Nom",
  EnterpriseDetail_signed_on: "Signé le",
  EnterpriseDetail_delivered_on: "Remis le",
  EnterpriseDetail_doc_warning: 'Les documents ci-dessous sont téléchargeables dans l\'espace “Doc&Sign” si ils vous ont été remis ou signés électroniquement sur le portail Salle des Marchés',
  EnterpriseDetail_status_of_document_contractual: 'STATUT DES DOCUMENTS DU PACK CONTRACTUEL',

  EnterpriseDetail_limit_tab_label: 'Limites d’engagement',
  EnterpriseDetail_limit_name: 'Nom de la limite',
  EnterpriseDetail_limit_montant_max: 'Montant de limite max',
  EnterpriseDetail_limit_montant_restant: 'Montant de limite restant',
  EnterpriseDetail_limit_date_expire: 'Date d’expiration',
  EnterpriseDetail_limit_date_snapshot: 'Date snapshot',

  Change_password_title: 'Modification du mot de passe',
  Change_password_success: 'Votre mot de passe a bien été modifié.',

  Newsletter_title: 'Abonnement aux notes d\'informations économiques',
  Newsletter_content_first: 'Pour vous inscrire ou changer vos préférences concernant les notes d\'informations économiques de la Salle des Marchés du Groupe ARKEA, merci de cliquer sur les publications proposées pour les sélectionner :',
  Newsletter_content_second: 'Veuillez noter que vos préférences ne sont pas enregistrées sur cette plateforme mais gérées par notre équipe Etudes économiques (la sélection ne sera pas conservée après envoi)',
  Newsletter_checkbox_pme_change: 'Flash Change',
  Newsletter_checkbox_pme_dette: 'Flash Taux',
  Newsletter_checkbox_pme_placement: 'Flash Placement',
  Newsletter_checkbox_pme_hebdo_eco: 'Hebdo éco',
  Newsletter_success: 'Merci, nous avons bien pris en compte votre demande. Votre adresse email va être intégrée dans nos prochains envois.',
  Newsletter_publication_change_description: 'Information quotidienne sur les opérations en devises',
  Newsletter_publication_dette_description: 'Information hebdomadaire sur les marchés de taux',
  Newsletter_publication_placement_description: 'Information hebdomadaire sur les exédents de trésorerie',
  Newsletter_publication_hebdo_eco_description: 'Information hebdomadaire sur les mouvements dans le monde',

  formanswers_title: 'Questionnaire compétence',
  formanswers_content: 'Afin d’accéder aux services d’investissement, nous vous demandons de répondre aux questions relatives à chaque type d’instrument financier sur lequel vous souhaitez opérer. Vos réponses nous servirons à vérifier que vous disposez du niveau de compétence suffisant pour appréhender les risques inhérents aux opérations sur instruments financiers.',
  formanswers_empty: 'Aucun formulaire à afficher',
  formanswers_messages_next: 'Suivant',
  formanswers_messages_upload: 'Télecharger',
  formanswers_messages_end: 'Sauvegarder',
  formanswers_messages_invalidFileSize: 'Le fichier est trop volumineux',
  formanswers_messages_invalidDate: 'Date invalide',
  formanswers_messages_invalidText: 'Saisie invalide',
  formanswers_messages_invalidPattern: 'Modèle invalide',
  formanswers_messages_previous: 'Précédent',
  formanswers_load_error: 'Error',
  formanswers_summary_no_answer: 'Aucune réponse pour cette question',
  formanswers_save_success: 'Votre réponse a été sauvegardée. Veuillez patienter pendant le chargement de la signature électronique...',

  qp_warning_oblig_titres_creance: 'Obligations et titres de créance',
  qp_warning_structure_complexe: 'Produits structurés complexes',
  qp_warning_change_ferme: 'Change ferme',
  qp_warning_change_conditionnel: 'Change conditionnel',
  qp_warning_taux_ferme: 'Taux ferme',
  qp_warning_taux_conditionnel: 'Taux conditionnel',
  qp_level_change: 'Change',
  qp_level_dette: 'Taux',
  qp_level_placement: 'Placement',

  qp_warning_user_without_habilitation: 'Désolé, vous n’avez pas les habilitations nécessaires pour répondre au questionnaire personne. Le questionnaire personne doit être complété par une personne habilitée pour pouvoir poursuivre sur la plateforme.',

  news_no_post: 'Pas d\'actualité dispo pour l\'instant',
  news_no_post_in_categories: 'Fin des actualités dans cette catégorie',
  news_filter_par_categories: 'Filtre par catégories:',
  news_filter_par_tags: 'Filtre par tags:',
  news_PME: 'Flash métier',
  news_FPP: 'Focus, tendances & perspectives',
  news_HEBDO: 'Hebdo éco',
  news_PME_description: 'Commentaires sur les dernières évolutions économiques',
  news_FPP_description: 'Analyses, projections et prévisions de marché',
  news_HEBDO_description: 'Retour sur une semaine d\'actualité économique',

  document_to_sign_first_label_first: 'Vous avez actuellement',
  document_to_sign_first_label_last_singular: 'document à signer',
  document_to_sign_first_label_last_plural: 'document(s) à signer',
  document_to_sign_second_label: 'Vous devez avoir le téléphone lié au numéro suivant pour signer électroniquement un document',
  document_to_sign_third_label_first: 'Seuls les documents pour lesquels vous êtes habilités sont visibles dans l’onglet ',
  document_to_sign_third_label_second: 'Ces documents peuvent être signés par d\'autres personnes habilitées. Si d\'autres personnes habilitées signent avant vous un document, celui-ci sera visible dans l\'onglet ',
  document_to_sign_warning_phone: 'Signature électronique impossible, votre numéro de téléphone portable n\'a pas été renseigné dans vos informations de profil. Ce numéro est obligatoire car il nous permet de vous transmettre vos codes de signature.',
  signature_date_signature: 'Date de signature',
  signature_date_send: 'Date d\'envoi',
  signature_date_expire: 'Date d’expiration',
  signature_category: 'Catégorie(s)',
  signature_description: 'Description',
  signature_name: 'Nom du document',
  signature_document: 'Document',
  signature_signatory: 'Signataire',
  signature_lastname_signatory: 'Nom signataire',
  signature_firstname_signatory: 'Prénom signataire',
  signature_mail_signatory: 'Email',
  signature_phone_signatory: 'Téléphone',
  signature_tunnel_prepare_waiting: 'Veuillez patienter pendant le chargement du tunnel de signature',

  ProductDetail_first_tab_lbl: 'Documents',
  ProductDetail_second_tab_lbl: 'Présentation',
  ProductDetail_third_tab_lbl: 'Avertissement & définitions',
  ProductDetail_alert_cotation: 'Les demandes de cotation seront prises en compte durant les heures d\'ouverture du service (entre 9h et 18h les jours ouvrés).',

  products_no_post: 'Pas produit dispo pour l\'instant',
  products_no_post_in_categories: 'Fin des produits dans cette catégorie',
  products_change: 'Change',
  products_placement: 'Placement',
  products_dette: 'Taux',
  products_filter_par_categorie: 'Filtre par catégorie:',
  products_global_search: 'Rechercher par nom de produit:',

  cotation_request: {
    first_step_lbl: 'Demande de cotation',
    second_step_lbl: 'Visualisation du payoff',
    third_step_lbl: 'Récapitulatif de la cotation',
    cotation_request_warning: 'Désolé vous n’avez pas les habilitations nécessaires pour effectuer une demande de cotation sur ce produit',
    second_step: {
      warning_default: 'Le graphique affiché est un graphique théorique qui ne tient pas compte des valeurs que vous avez renseignées',
    },
    gauge: {
      red: 'Les informations que vous avez renseignées sont insuffisantes. Nous vous contacterons pour définir votre demande',
      orange: 'Les informations fournies sont incomplètes. Nous vous contacterons pour affiner votre demande',
      yellow: 'Les informations fournies sont suffisantes. Nous rechercherons le paramètre manquant pour répondre au mieux à votre demande',
      green: 'Les informations fournies sont complètes. Nous répondrons à votre demande dans les plus brefs délais'
    },
    request_success: 'Votre demande de cotation est transmise à la Salle des Marchés du Groupe ARKEA'
  },

  Cotation_table_first_tab_lbl: 'En cours',
  Cotation_table_second_tab_lbl: 'Expirées',
  Cotation_table_third_tab_lbl: 'Finalisées',
  Cotation_table_column_last_update_at: 'Modification',
  Cotation_table_column_created_at: 'Création',
  Cotation_table_column_name: 'Nom du produit',
  Cotation_table_column_sale_branch_name: 'Antenne commerciale',
  Cotation_table_column_status: 'Statut',
  Cotation_table_column_assignment: 'Attribution',
  Cotation_table_column_type_of_product: 'Type de produit',
  Cotation_table_column_category_of_product: 'Catégories',
  Cotation_table_detail: 'Détails',
  Cotation_table_duplicate: 'Dupliquer',
  Cotation_table_pass_for_expire: 'Passer en expirée',
  Cotation_table_pass_for_live: 'Passer en live',
  Cotation_table_pass_for_expire_modal_title: 'Passer en expirée',
  Cotation_table_pass_for_expire_modal_content: 'Cette action est irréversible, la cotation sera expirée.',
  Cotation_table_pass_for_live_modal_title: 'Passer en live',
  Cotation_table_pass_for_live_modal_content: 'Cette action est irréversible, la cotation sera live',
  Cotation_table_pass_for_done_modal_title: 'Passer en finalisée',
  Cotation_table_pass_for_done_modal_content: 'Cette action est irréversible, la cotation sera finalisée',
  Cotation_table_duplicate_modal_title: 'Dupliquer cette cotation',
  Cotation_table_duplicate_modal_content: 'Vous allez dupliquer cette cotation. Souhaitez-vous poursuivre ? La duplication conservera les paramètres déjà renseignés sur la dernière version de la cotation en cours mais tous les échanges avec la Salle des Marchés ne seront pas dupliqués.',
  Cotation_chart_warning: 'Le graphique affiché est un graphique théorique qui ne tient pas compte des valeurs que vous avez renseignées',
  Cotation_chart_error: 'Nous ne disposons pas de suffisamment de paramètres pour afficher le graphique réel de payoff. Complétez les paramètres de cotation pour afficher le graphique.',
  Cotation_control_qp_alert_no_appropriate: 'vous n’avez ni la connaissance ni l’expérience sur cette catégorie de produit MIF',
  Cotation_control_qp_alert_knowledge_only: 'vous n’avez pas l’expérience sur cette catégorie de produit MIF',
  Cotation_control_qp_alert_experience_only: 'vous n’avez pas la connaissance sur cette catégorie de produit MIF',
  Cotation_status_LIVE: 'En cours',
  Cotation_status_EXPIRED: 'Expirée',
  Cotation_status_DONE: 'Finalisée',
  Cotation_status_DRAFT: 'Brouillon',
  Cotation_no_charts: 'Il n\'y a pas de graphique disponible',
  Cotation_graphic_payoff: 'payoff graphique',
  Cotation_last_version: 'Versions précédentes des paramètres',
  Cotation_setting_params: 'Paramètres de la cotation',
  Cotation_has_been_modifed: 'a modifié les paramètres le ',
  Cotation_notified_people: 'Personnes a notifier',
  Cotation_params_reserved_for_arkea: 'PARAMÈTRES RÉSERVÉS À LA SALLE DES MARCHÉS',
  Cotation_table_warning: 'Les cotations en cours passeront au statut "expirée" au bout de 7 jours d’inactivité',
  Cotation_summary_request_initial_by: 'Demande initiée par :',
  Cotation_summary_request_quote_gauge: 'Jauge de demande de cotation',
  Cotation_summary_person_to_notify: 'Personnes à notifier de l’évolution de la cotation :',
  Cotation_vendor_settings: 'Paramètres réservés au vendeur',
  Cotation_user_settings: 'Rappel des paramètres que vous avez renseignés',

  Transactions: {
    first_tab: 'Change',
    second_tab: 'Taux',
    third_tab: 'Placement',

    created_at: 'Crée le',
    status: 'Statut',
    category_produit: 'Catégorie(s)',
    type_de_trade: 'Type de trade',
    numero_du_trade: 'Numéro du trade',
    numero_du_contrat: 'Numéro du contrat',
    code_strategy: 'Code strategy',
    efs_code: 'EFS code',
    distributor_network: 'Distributor network',
    topaze_id: 'Topaze ID',
    typologie_operation: 'Type d\'opération',
    type_de_produit: 'Type de produit',
    date_operation: 'Date de l\'opération',
    date_de_valeur_operation: 'Date de valeur',
    date_expiration: 'Date expiration',
    date_de_maturite: 'Date de maturité',
    nominal: 'Nominal',
    nominal_restant: 'Nominal restant',
    filter_status: 'Statut des opérations',
    document: 'Document',
    documents: 'Documents',
    cours_or_taux: 'Cours / Taux (%)',
    modal: {
      helper_info_transaction: (contractNumber): string => `Confirmations de l'opération ${contractNumber}`,
      helper_transaction_first: 'Les confirmations ci-dessous sont également accessibles dans l\'espace',
      helper_transaction_second: 'en tapant la référence de l’opération dans la barre de recherche'
    },

    change: {
      import_export: 'Sens',
      indicateur_call_put: 'Type d\'option',
      sens_du_trade_1: 'Achat/Vente d\'option',
      devise_1: 'Devise 1',
      devise_2: 'Devise 2',
      prix_exercice_option_1: 'Prix d\'exercice de l\'option',
      cours_spot: 'Cours Spot',
      cours_terme: 'Cours Terme',
      style_de_barriere: 'Type de barrière',
      tooltip_style_de_barriere: 'A = American, E = European, D = Down, U = Up, I = In, O = Out',
      tooltip_style_de_barriere_ex: 'Exemple : ADO = American Down & Out',
      niveau_barriere: 'Niveau de barrière',
      fx_accu_engagment_mise_en_place: 'Montant max de l\'accumulateur',
      fx_accu_montant_max_accumulable_par_fixing: 'Montant max accumulable par fixing',
      fx_accu_montant_accumule_non_leve: 'Montant accumulé non levé',
      fx_accu_barriere_inferieure: 'Borne inférieure de l\'accumulateur',
      fx_accu_barriere_superieure: 'Borne supérieure de l\'accumulateur',
      ratios_accumulation: 'Ratios d\'accumulation',
      valorisation_cc: 'Valorisation (€)',
      montant_couru: 'Coupon couru (€)',
      date_valorisation: 'Date de valorisation',
      accumulator_fixing: "Fixings restants de l’accumulateur",
      accumulator_fixing_frequency: "Fréquence de fixing de l’accumulateur",
      next_fixing_date: "Date du prochain fixing",
      figures_reserve: "Réserve de figures",
      figures_consumption: "Consommation de figures",
    },
    dette: {
      categorie_fo_risque_de_produit: 'Catégorie Gissler',
      date_de_paiement_du_flux_interet_1: 'Date du prochain flux (patte 1)',
      sens_du_trade_1: 'Sens (patte 1)',
      devise_1: 'Devise (patte 1)',
      type_de_taux_1: 'Type de Taux  (patte 1)',
      taux_1: 'Taux (patte 1)',
      floored_rate_1: 'Taux flooré (patte 1)',
      structured_rate_1: 'Taux structuré (patte 1)',
      date_de_paiement_du_flux_interet_2: 'Date du prochain flux (patte 2)',
      sens_du_trade_2: 'Sens (patte 2)',
      devise_2: 'Devise (patte 2)',
      type_de_taux_2: 'Type de Taux (patte 2)',
      taux_2: 'Taux (patte 2)',
      floored_rate_2: 'Taux flooré (patte 2)',
      structured_rate_2: 'Taux structuré (patte 2)',
      prix_exercice_option_1: 'Prix d\'exercice de l\'option 1',
      style_de_barriere: 'Style de barrière',
      niveau_barriere: 'Niveau de barrière',
      strike_option_1: 'Strike de l\'option 1',
      strike_option_2: 'Strike de l\'option 2',
      valorisation_pdc: 'Valorisation pied de coupon (€)',
      valorisation_cc: 'Valorisation coupon couru inclus (€)',
      montant_couru: 'Coupon couru (€)',
      date_valorisation: 'Date de valorisation',
    },
    placement: {
      code_isin: 'Code ISIN',
      date_de_paiement_du_flux_interet_1: 'Date du prochain coupon',
      clean_price: 'Clean price',
      sens_du_trade_1: 'Sens',
      devise_1: 'Devise',
      type_de_taux_1: 'Type de Taux ',
      taux_1: 'Taux',
      structured_rate_1: 'Taux structuré',
      prix_exercice_option_1: 'Prix d\'exercice de l\'option 1',
      style_de_barriere: 'Style de barrière',
      niveau_barriere: 'Niveau de barrière',
      strike_option_1: 'Strike de l\'option 1',
      strike_option_2: 'Strike de l\'option 2',
      strike: 'Strike',
      date_de_strike: 'Date de strike',
      prochain_fixing: 'Date du prochain fixing',
      cours: 'Cours',
      valorisation_pdc: 'Valorisation pied de coupon (€)',
      valorisation_cc: 'Valorisation coupon couru inclus (€)',
      montant_couru: 'Coupon couru (€)',
      date_valorisation: 'Date de valorisation',
    }
  },

  cgu_title: 'Validation des conditions générales',
  cgu_first_lbl: 'J’ai lu et j’accepte les conditions générales des services Solutions de Marchés à Distance',
  cgu_second_lbl: 'J’accepte la dématérialisation de mes documents ARKEA Salle des Marchés',
  cgu_third_lbl: 'J’active les notifications par mail',

  Contact_your_sales_office: 'Votre antenne commerciale',
  contact_phone_number_message:   `*Appel non surtaxé, hors coûts éventuels liés à l'opérateur de télécommunications`,
  contact_title: "Contacter nos Salles des Marchés en région",

  notification_accept_label: 'Accepter de recevoir les notifications par mail en provenance du portail (envoi de documents à signer/consulter, actualisation des cotations, ...)',
  notification_active_label: 'Les notifications par mail sont activées. Vous pouvez cliquer sur le bouton ci-contre pour les désactiver',
  notification_inactive_label: 'Les notifications par mail (envoi de documents, cotations, …) sont désactivées. Veuillez cliquer sur le bouton ci-contre pour les activer',
  user_notification_active_label: 'Vos notifications par mail sont activées. Vous pouvez cliquer sur le bouton ci-contre pour les désactiver',
  user_notification_inactive_label: 'Vos notifications par mail (envoi de documents, cotations, …) sont désactivées. Veuillez cliquer sur le bouton ci-contre pour les activer',

  Dashboard_no_cotation: 'Il n\'y a pas de cotation disponible',
  Dashboard_no_news: 'Il n\'y a pas d\'actualité disponible',
  Dashboard_no_transactions: 'Il n\'y a pas d\'operation disponible',
  Dashboard_no_signatures: 'Il n\'y a pas de document disponible',

  categories_filter_label: 'Choisir des catégories',

  transactions_alert_habilitations: 'Désolé, vous n’avez pas les habilitations métiers nécessaires pour accéder à ce tableau.',

  Table_row_per_page: 'Lignes par page',
  Table_displayed_rows: (from, to, count): string => `${from}-${to} sur ${count}`,

  App_title_page_Main: "ARKEA - Solutions de Marchés",
  App_title_page_Plateform: "Espace client",
  App_title_page_Dashboard: "Tableau de bord",
  App_title_page_News: "Actualités",
  App_title_page_Form: "Formulaire",
  App_title_page_TunnelValidation: "Tunnel de validation de profil",
  App_title_page_ChangePassword: "Modification du mot de passe",
  App_title_page_Profile: "Profil",
  App_title_page_Newsletter: "Abonnement aux notes d'informations économiques",
  App_title_page_Enteprise: "Détail entreprise",
  App_title_page_Products: "Produits",
  App_title_page_Cotations: "Cotations",
  App_title_page_EcoWatch: "Etudes économiques",
  App_title_page_Signature: "Documents et signatures",
  App_title_page_kyc: "Envoi de documents",
  App_title_page_Transactions: "Opérations",
  App_title_page_Contact: "Contact",
  App_title_page_CGU: "Conditions générales d’utilisation",
  App_title_page_MarketIndicators: "Indicateurs de marchés",

  Documents_file_name: 'Nom du fichier',
  Document_must_be_signed: 'Le document doit être signé',
  Document_custom_category: 'Préciser le type de document',
  Document_send_success: 'Document envoyé avec succès',
  Document_tunnel_redirect: 'Envoi de document certifié par signature électronique, veuillez patienter pendant le chargement',

  market_indicators_page_title: "Indicateurs de marchés",
  market_indicators_page_warning: "Les indicateurs affichés sur cette page vous sont proposés à titre purement informatif pour vous donner les principales tendances de marchés. Ils ne constituent pas de niveaux sur lesquels des opérations pourraient être négociées ou conclues avec la Salle des Marchés du Groupe ARKEA.",
  market_indicators_tab_indices_actions_lbl: "INDICES ACTIONS",
  market_indicators_tab_change_spot_lbl: "CHANGE SPOT"
};



// WEBPACK FOOTER //
// ./src/core/i18n/messages/messages.fr.ts